import { useMap } from "@vis.gl/react-google-maps";
import { useEffect, useState } from "react";

const degreesPerPixel = zoom => 360 / (Math.pow(2, zoom) * 256);

// Tracks the map's current bounding box ([west, south, east, north]) and zoom,
// updated on `idle` so supercluster can query only what's in view.
export function useMapViewport({ padding = 0 } = {}) {
  const map = useMap();
  const [bbox, setBbox] = useState([-180, -90, 180, 90]);
  const [zoom, setZoom] = useState(0);

  useEffect(() => {
    if (!map) {
      return;
    }

    const listener = map.addListener("idle", () => {
      const bounds = map.getBounds();
      const currentZoom = map.getZoom();
      const projection = map.getProjection();

      if (!bounds || !currentZoom || !projection) {
        return;
      }

      const sw = bounds.getSouthWest();
      const ne = bounds.getNorthEast();
      const paddingDegrees = degreesPerPixel(currentZoom) * padding;

      setBbox([
        sw.lng() - paddingDegrees,
        Math.max(-90, sw.lat() - paddingDegrees),
        ne.lng() + paddingDegrees,
        Math.min(90, ne.lat() + paddingDegrees),
      ]);
      setZoom(currentZoom);
    });

    return () => listener.remove();
  }, [map, padding]);

  return { bbox, zoom };
}
